import { roundCents, formatAUD } from "@/lib/format";

// Item 6 wording: "Receives {amount} from company" / "Owes company {amount}".
export function headline(result) {
  const r = roundCents(result);
  if (Number(r) === 0) return { text: "Settled", tone: "text-muted-foreground" };
  if (r.startsWith("-")) return { text: `Owes company ${formatAUD(r.slice(1))}`, tone: "text-rose-300" };
  return { text: `Receives ${formatAUD(r)} from company`, tone: "text-emerald-300" };
}
